import React, { useState, useEffect } from "react";
import axios from "axios";
import SmartLink from "../../utils/SmartLink";
import LogoMedata from "../../medatatheme/assets/images/logo.png";
import LogoAlcaldia from "../../medatatheme/assets/images/logo-alcaldia.png";
import LogoCo from "../../medatatheme/assets/images/logo-co.png";
import LogoGov from "../../medatatheme/assets/images/logo-gov.png";

const Header = () => {
  const [linksInteres, setLinksInteres] = useState([]);
  const [loading, setLoading] = useState(true);

  // Links de respaldo en caso de que falle la API
  const fallbackLinks = [
    { id: "fallback-1", title: "Portal Alcaldía de Medellín", url: "https://www.medellin.gov.co/" },
    { id: "fallback-2", title: "Página Corporación Ruta N", url: "https://www.rutanmedellin.org/" },
    { id: "fallback-3", title: "Portal Datos Abiertos Colombia", url: "https://www.datos.gov.co/" }
  ];

  useEffect(() => {
    const fetchLinksInteres = async () => {
      try {
        // Usar el endpoint custom que es accesible para usuarios anónimos
        const response = await axios.get('/api/menu/links-interes');

        if (response.data && response.data.data && response.data.data.length > 0) {
          const links = response.data.data.map(item => ({
            id: item.id,
            title: item.title,
            url: item.url,
            weight: item.weight
          }));
          setLinksInteres(links);
        } else {
          setLinksInteres(fallbackLinks);
        }
      } catch (error) {
        console.error('Error fetching links de interés:', error);
        setLinksInteres(fallbackLinks);
      } finally {
        setLoading(false);
      }
    };

    fetchLinksInteres();
  }, []);

  return (
    <section className="contact-section">
      <div className="container-home">
        <div className="grid">
          <div className="contact-containers">
            <p className="contact-title">Links de interés</p>
            <hr className="contact-separator" />
            <ul className="contact-list">
              {loading ? (
                <li className="contact-item">
                  <span className="contact-decorator"></span>
                  <span className="contact-link">Cargando...</span>
                </li>
              ) : (
                linksInteres.map((link) => (
                  <li key={link.id || link.title} className="contact-item">
                    <span className="contact-decorator"></span>
                    <SmartLink to={link.url} className="contact-link">{link.title}</SmartLink>
                  </li>
                ))
              )}
            </ul>
          </div>
          <div className="contact-containers">
            <p className="contact-title">Contacto</p>
            <hr className="contact-separator" />
            <ul className="contact-list">
              <li className="contact-item">
                <span className="contact-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </span>
                <a href="#!" className="contact-link">Calle 44 N 52 – 165 Centro Administrativo la Alpujarra
                  – Medellín, Colombia.</a>
              </li>
              <li className="contact-item">
                <span className="contact-icon">
                  <i className="fa-solid fa-envelope"></i>
                </span>
                <a href="mailto:medata@medellin.gov.co" className="contact-link">medata@medellin.gov.co</a>
              </li>
              <li className="contact-item">
                <span className="contact-icon">
                  <i className="fa-solid fa-phone"></i>
                </span>
                <a href="tel:+5744444144" className="contact-link">Línea única de atención ciudadana: (574) 44 44 144</a>
              </li>
              <li className="contact-item">
                <span className="contact-icon">
                  <i className="fa-solid fa-headset"></i>
                </span>
                <a href="tel:018000411144" className="contact-link">Línea gratuita nacional: 01 8000 411 144</a>
              </li>
            </ul>
          </div>
          <div
            className="contact-containers contact-social-container d-flex justify-content-center align-items-center">
            <SmartLink to="/" className="logo">
              <img src={LogoMedata} alt="Logo MeData" />
            </SmartLink>
            <p className="text text-white text-center">
              MEData es la estrategia de datos de la ciudad de Medellín, que busca la apropiación,
              apertura y uso de los datos como herramienta de gobierno, acción ciudadana y toma de
              decisiones.
            </p>
          </div>
        </div>
        <div className="contact-privacity d-flex align-items-center justify-content-center">
          <p className="text text-white">Copyright © Medata 2022 ® todos los derechos reservados</p>
          <p className="text text-secondary"><a href="https://www.medellin.gov.co/es/transparencia/politica-de-tratamientos-de-datos/">Condiciones de Uso</a></p>
          <p className="text text-secondary"><a href="https://www.medellin.gov.co/es/transparencia/politica-de-tratamientos-de-datos/">Políticas de Privacidad</a></p>
          {/* Acceso al login de administración de Drupal (/user/login). Va como
              <a href> normal porque la ruta la sirve Drupal, no la SPA. */}
          <p className="text text-white"><a href="/user/login" className="text-white">Iniciar sesión</a></p>
        </div>
      </div>
      <div className="footer">
        <div className="footer-container">
          <a href="https://www.medellin.gov.co/" className="footer-brand">
            <img src={LogoAlcaldia} alt="Logo alcaldía de Medellín" />
          </a>
          <div className="footer-logos">
            <SmartLink to="/" className="footer-brand">
              <img src={LogoCo} alt="Logo Co" />
            </SmartLink>
            <a href="https://www.gov.co/" className="footer-brand">
              <img src={LogoGov} alt="Logo gobernación" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
